/*
 * Copyright (c) 2022 Virginia Tech Transportation Institute.  All rights reserved.
 */
import React from 'react'
import isNil from "crocks/predicates/isNil"
import isEmpty from "crocks/predicates/isEmpty"
import Typography from "@material-ui/core/Typography"
import LinearProgress from "@material-ui/core/LinearProgress"
import { makeStyles } from "@material-ui/core/styles"
import ContentContainer from "../../common/components/ContentContainer"
import { useFunctionalScenarioState } from './FunctionalScenarioStateProvider'
import { groupArrayBy } from '../../common/util/array'
import ScenarioAppCard from './SceanrioAppCard'

const createLoading = () => <LinearProgress />

const createEmptyAppList = (classes) => (
  <div className={classes.emptyRoot}>
    <Typography>Sorry, there are no functional scenarios available at this time.</Typography>
  </div>
)

function scenarioMapper(scenarios) {
  const result = []
  const groupedScenarios = groupArrayBy(scenarios, a => a.rowCategory)

  for (var [name, scenarioGroup] of groupedScenarios) {
    result.push(<ScenarioAppCard key={name} name={name} scenarios={scenarioGroup} />)
  }

  return result
}

const useStyles = makeStyles(theme => ({
  contentContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  appGrid: {
    display: 'grid',
    justifyItems: 'center',
    gridGap: '8px',
    gridTemplateRows: 'repeat(auto-fit, 180px)',
    gridTemplateColumns: 'repeat(auto-fit, minmax(480px, 1fr))',
    padding: 8,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '75%',
    },
  },
  emptyRoot: {
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      margin: theme.spacing(4),
    }
  },
}))

function FunctionalScenarioAppGrid() {
  const classes = useStyles()
  const { scenarios } = useFunctionalScenarioState()

  if (isNil(scenarios)) {
    return createLoading()
  }

  if (isEmpty(scenarios)) {
    return createEmptyAppList(classes)
  }

  console.log('functional scenarios', scenarios)

  return (
    <ContentContainer className={classes.contentContainer}>
      <div className={classes.appGrid}>
        {scenarioMapper(scenarios)}
      </div>
    </ContentContainer>
  )
}

export default FunctionalScenarioAppGrid
